const local = "http://localhost:3021";
const development = "https://ilshinapi.likeweb.co.kr";
const production = "https://apiweb.ilshingroup.com";

const { host, port } = window.location;
const parts = host.split(".");

const isLocalMode = parts.some(p => p.startsWith("localhost")); // 로컬모드
const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

const isDevelop = isDomainDevelop || isDevMode;

export const api_uri = isLocalMode ? local : isDevelop ? development : production;

//--------------------------------- 관리자 ---------------------------------
export const enum_api_uri = {
    api_uri: `${api_uri}`,
    // --------------------항공--------------------
    air_login: `${api_uri}/v1/air/auth/login`,
    customer_sale: `${api_uri}/v1/air/customer/sale`,
    customer_sale_excel: `${api_uri}/v1/air/customer/sale/excel`,
    customer_tracking: `${api_uri}/v1/air/customer/tracking`,
    customer_bill: `${api_uri}/v1/air/customer/bill`,
    customer_bl_down: `${api_uri}/v1/air/customer/sale`,
    customer_bill_sum: `${api_uri}/v1/air/customer/bill/sum`,
    customer_pickup: `${api_uri}/v1/air/customer/pickup`,
    customer_estimate: `${api_uri}/v1/air/customer/estimate`,
    get_supplies_request: `${api_uri}/v1/air/customer/supplies-request/:category`,
    post_supplies_request: `${api_uri}/v1/air/customer/supplies-request/:category`,
    delete_supplies_request: `${api_uri}/v1/air/customer/supplies-request/:category`,
    put_supplies_request: `${api_uri}/v1/air/customer/supplies-request/:category/:list_no`,
    get_supplies_request_detail: `${api_uri}/v1/air/customer/supplies-request/:category/:list_no`,

    // ------------------- 모닝택배 -------------------
    login: `${api_uri}/v1/delivery/auth/login`,
    add_order: `${api_uri}/v1/delivery/order/tmpAdd`,
    tmp_view: `${api_uri}/v1/delivery/order/tmpView`,
    tmp_edit: `${api_uri}/v1/delivery/order/tmpEdit`,
    tmp_remove: `${api_uri}/v1/delivery/order/tmpRemove`,
    tmp_list: `${api_uri}/v1/delivery/order/tmpList`,
    dept: `${api_uri}/v1/delivery/order/dept`,
    order_search: `${api_uri}/v1/delivery/order/search`,
    order: `${api_uri}/v1/delivery/order/accept`,
    last_order: `${api_uri}/v1/delivery/order/lastOrder`,
    order_file: `${api_uri}/v1/delivery/order/file`,
    bill_excel: `${api_uri}/v1/delivery/bill/list/excel`,
    scan_img: `${api_uri}/v1/delivery/bill/image/generate/:s_bl_no`,

    tracking_pop_print: `${api_uri}/v1/delivery/tracking/popPrint`,
    tracking_link_print: `${api_uri}/v1/delivery/tracking/linkPrint`,
    tracking_pop_print_view: `${api_uri}/v1/delivery/tracking/popPrintView`,
    post_tracking_pop_cancel_print: `${api_uri}/v1/delivery/tracking/popCancelPrint`,
    tracking_list: `${api_uri}/v1/delivery/tracking/list`,
    tracking_list_excel: `${api_uri}/v1/delivery/tracking/list/excel`,
    tracking_history: `${api_uri}/v1/delivery/request/trackingLast`,
    tracking_pop: `${api_uri}/v1/delivery/tracking/popView`,
    tracking_pop_bill: `${api_uri}/v1/delivery/tracking/popBill`,
    tracking_add_print: `${api_uri}/v1/delivery/tracking/popAddPrintView`,
    order_add_print: `${api_uri}/v1/delivery/tracking/popAddOrder`,
    order_add_next_print: `${api_uri}/v1/delivery/tracking/popAddNextOrder`,
    edit_tracking_pop: `${api_uri}/v1/delivery/tracking/popModify`,
    tracking_detail: `${api_uri}/v1/delivery/tracking/detail`,
    tracking_detailA: `${api_uri}/v1/delivery/tracking/detailA`,
    tracking_cancel: `${api_uri}/v1/delivery/tracking/popCancel`,
    tracking_select_cancel: `${api_uri}/v1/delivery/tracking/selectCancel`,
    tracking_memo: `${api_uri}/v1/delivery/tracking/popMemoModify`,
    put_a_request: `${api_uri}/v1/delivery/tracking/popARequestModify`,
    bill_list: `${api_uri}/v1/delivery/bill/list`,
    request_list: `${api_uri}/v1/delivery/request/list`,
    post_register: `${api_uri}/v1/delivery/request/register`,
    post_register_tracking: `${api_uri}/v1/delivery/request/tracking`,
    get_request_view: `${api_uri}/v1/delivery/request/view`,
    put_register: `${api_uri}/v1/delivery/request/update`,
    delete_request: `${api_uri}/v1/delivery/request/delete`,

    post_recruit: `${api_uri}/v1/board/recruit/:category`,

    // --------------------퀵--------------------
    quick_login: `${api_uri}/v1/quick/auth/login`,
    quick_member: `${api_uri}/v1/quick/customer/member`,

    quick_customer_order: `${api_uri}/v1/quick/customer/order`,
    quick_customer_settlements: `${api_uri}/v1/quick/customer/settlements`,
    quick_customer_group: `${api_uri}/v1/quick/customer/settlements/group`,
    quick_customer_detail: `${api_uri}/v1/quick/customer/settlements/detail`,

    // --------------------특송--------------------
    express_login: `${api_uri}/v1/express/auth/login`,
    express_member: `${api_uri}/v1/express/customer/member`,

    express_customer_order: `${api_uri}/v1/express/customer/order`,
    express_customer_settlements: `${api_uri}/v1/express/customer/settlements`,
    express_customer_group: `${api_uri}/v1/express/customer/settlements/group`,
    express_customer_detail: `${api_uri}/v1/express/customer/settlements/detail`,

    // 마이페이지
    address: `${api_uri}/v1/delivery/mypage/address`,
    info: `${api_uri}/v1/delivery/mypage/info`,
    business_day: `${api_uri}/v1/delivery/pickup/business-day`, // 오늘 휴무일·업무 종료시간(서버 판정)
    get_alarm: `${api_uri}/v1/delivery/mypage/alarm`,
    get_counter: `${api_uri}/v1/delivery/mypage/counter`,
    put_info: `${api_uri}/v1/delivery/mypage/infoModify`,
    post_address: `${api_uri}/v1/delivery/mypage/addressAdd`,
    get_address_view: `${api_uri}/v1/delivery/mypage/addressView`,
    put_address: `${api_uri}/v1/delivery/mypage/addressModify`,
    put_default_address: `${api_uri}/v1/delivery/mypage/infoModify`,
    delete_address: `${api_uri}/v1/delivery/mypage/addressDelete`,
    post_print_advance: `${api_uri}/v1/delivery/mypage/blNoAdd`,

    // 공통
    get_notices: `${api_uri}/v1/board/notice/:category`,
    get_notice_detail: `${api_uri}/v1/board/notice/:category/:list_no`,
    get_faq: `${api_uri}/v1/board/faq/:category`,
    get_faq_detail: `${api_uri}/v1/board/faq/:category/:list_no`,
    get_order_status: `${api_uri}/v1/delivery/customer/order`,
    get_board_rate: `${api_uri}/v1/board/rate`,
    get_popups: `${api_uri}/v1/board/popup/:category`,

    // 관리자
    console_login: `${api_uri}/v1/admin/auth/login`,

    // 콘솔 관리자 계정 CRUD (admin/abcdkdh 전용)
    get_console_admin_accounts: `${api_uri}/v1/admin/account`,
    post_console_admin_account: `${api_uri}/v1/admin/account`,
    get_console_admin_account_detail: `${api_uri}/v1/admin/account/:idx`,
    put_console_admin_account: `${api_uri}/v1/admin/account/:idx`,
    delete_console_admin_account: `${api_uri}/v1/admin/account/:idx`,

    get_console_notices: `${api_uri}/v1/admin/board/notice/:category`,
    get_console_faq: `${api_uri}/v1/admin/board/faq/:category`,
    get_console_recruit: `${api_uri}/v1/admin/board/recruit/:category`,
    get_console_recruit_status: `${api_uri}/v1/admin/board/recruit/status/:category`,
    get_console_popups: `${api_uri}/v1/admin/popup/:category`,
    post_console_popup: `${api_uri}/v1/admin/popup/:category`,
    get_console_popup_detail: `${api_uri}/v1/admin/popup/:category/:idx`,
    delete_console_popup: `${api_uri}/v1/admin/popup/:category`,
    put_console_popup: `${api_uri}/v1/admin/popup/:category/:idx`,
    post_console_notice: `${api_uri}/v1/admin/board/notice/:category`,
    get_console_notice_detail: `${api_uri}/v1/admin/board/notice/:category/:list_no`,
    put_console_notice: `${api_uri}/v1/admin/board/notice/:category/:list_no`,
    delete_console_notice: `${api_uri}/v1/admin/board/notice/:category`,
    get_console_faq_detail: `${api_uri}/v1/admin/board/faq/:category/:list_no`,
    post_console_faq: `${api_uri}/v1/admin/board/faq/:category`,
    put_console_faq: `${api_uri}/v1/admin/board/faq/:category/:list_no`,
    delete_console_faq: `${api_uri}/v1/admin/board/faq/:category`,
    get_console_estimate: `${api_uri}/v1/admin/estimate`,
    delete_console_estimate: `${api_uri}/v1/admin/estimate`,
    get_console_estimate_detail: `${api_uri}/v1/admin/estimate/:list_no`,
    put_console_estimate: `${api_uri}/v1/admin/estimate/:list_no`,
    get_console_order_customer: `${api_uri}/v1/admin/order/customer`,
    get_console_quick_order: `${api_uri}/v1/admin/order/quick`,
    get_console_express_order: `${api_uri}/v1/admin/order/express`,
    get_console_order_info: `${api_uri}/v1/admin/order/:category/:serial_number`,
    get_console_supplies: `${api_uri}/v1/admin/supplies-request/:category`,
    delete_console_supplies: `${api_uri}/v1/admin/supplies-request/:category`,
    get_console_supplies_detail: `${api_uri}/v1/admin/supplies-request/:category/:list_no`,
    put_console_supplies: `${api_uri}/v1/admin/supplies-request/:category/:list_no`,
    put_console_supplies_status: `${api_uri}/v1/admin/supplies-request/:category/:list_no/status`,
    post_console_supplies_comment: `${api_uri}/v1/admin/supplies-request/:category/:list_no`,
    put_console_supplies_comment: `${api_uri}/v1/admin/supplies-request/:category/:list_no/:c_list_no`,
    delete_console_supplies_comment: `${api_uri}/v1/admin/supplies-request/:category/:list_no/:c_list_no`,
    get_console_way_bill: `${api_uri}/v1/admin/way-bill/:category`,
    delete_console_way_bill: `${api_uri}/v1/admin/way-bill/:category`,
    get_console_way_bill_detail: `${api_uri}/v1/admin/way-bill/:category/:list_no`,
    put_console_way_bill: `${api_uri}/v1/admin/way-bill/:category/:list_no`,
    post_console_way_bill_comment: `${api_uri}/v1/admin/way-bill/:category/:list_no`,
    put_console_way_bill_comment: `${api_uri}/v1/admin/way-bill/:category/:list_no/:c_list_no`,
    delete_console_way_bill_comment: `${api_uri}/v1/admin/way-bill/:category/:list_no/:c_list_no`,
    get_console_air_pickup: `${api_uri}/v1/admin/pickup`,
    delete_console_air_pickup: `${api_uri}/v1/admin/pickup`,
    put_console_air_pickup_status: `${api_uri}/v1/admin/pickup/:list_no`,
    get_console_air_pickup_detail: `${api_uri}/v1/admin/pickup/:list_no`,
    post_console_express_order: `${api_uri}/v1/admin/order/express/:list_no`,
    put_console_express_order: `${api_uri}/v1/admin/order/express/:list_no`,
    get_console_bill: `${api_uri}/v1/admin/bill/:category`,
    put_console_bill: `${api_uri}/v1/admin/bill/:category/:list_no`,
    get_console_bill_detail: `${api_uri}/v1/admin/bill/:category/:list_no`,
    delete_console_bill: `${api_uri}/v1/admin/bill/:category`,
    post_console_bill_comment: `${api_uri}/v1/admin/bill/:category/:list_no`,
    put_console_bill_comment: `${api_uri}/v1/admin/bill/:category/:list_no/:c_list_no`,
    delete_console_bill_comment: `${api_uri}/v1/admin/bill/:category/:list_no/:c_list_no`,
    get_console_qr_system_request: `${api_uri}/v1/admin/qrcode/request`,
    get_console_qr_system_request_detail: `${api_uri}/v1/admin/qrcode/request/:list_no`,
    put_console_qr_system_request: `${api_uri}/v1/admin/qrcode/request/:list_no`,
    delete_console_qr_system_request: `${api_uri}/v1/admin/qrcode/request`,
    post_console_qr_system_comment: `${api_uri}/v1/admin/qrcode/request/:list_no`,
    put_console_qr_system_comment: `${api_uri}/v1/admin/qrcode/request/:list_no/:c_list_no`,
    delete_console_qr_system_comment: `${api_uri}/v1/admin/qrcode/request/:list_no/:c_list_no`,
    get_console_qr_system_monthly_status: `${api_uri}/v1/admin/qrcode/request-status`,
    get_console_bl_images: `${api_uri}/v1/admin/bl-image`,
    post_console_bl_images: `${api_uri}/v1/admin/bl-image`,
    delete_console_bl_images: `${api_uri}/v1/admin/bl-image/:s_bl_no`,

    // 모닝택배 - 기사 관리
    get_console_drivers: `${api_uri}/v1/admin/morning/driver`,
    post_console_driver: `${api_uri}/v1/admin/morning/driver`,
    get_console_driver_detail: `${api_uri}/v1/admin/morning/driver/:driver_no`,
    put_console_driver: `${api_uri}/v1/admin/morning/driver/:driver_no`,
    delete_console_driver: `${api_uri}/v1/admin/morning/driver`,
    // 모닝택배 - 입고지 관리
    get_console_warehouses: `${api_uri}/v1/admin/morning/warehouse`,
    post_console_warehouse: `${api_uri}/v1/admin/morning/warehouse`,
    get_console_warehouse_detail: `${api_uri}/v1/admin/morning/warehouse/:warehouse_no`,
    put_console_warehouse: `${api_uri}/v1/admin/morning/warehouse/:warehouse_no`,
    delete_console_warehouse: `${api_uri}/v1/admin/morning/warehouse`,
    // 모닝택배 - 일자별 입고지 기사 관리
    get_console_driver_schedules: `${api_uri}/v1/admin/morning/driver-schedule`,
    post_console_driver_schedule: `${api_uri}/v1/admin/morning/driver-schedule`,
    get_console_driver_schedule_detail: `${api_uri}/v1/admin/morning/driver-schedule/:schedule_no`,
    put_console_driver_schedule: `${api_uri}/v1/admin/morning/driver-schedule/:schedule_no`,
    delete_console_driver_schedule: `${api_uri}/v1/admin/morning/driver-schedule`,
    // 모닝택배 - 휴무일 관리
    get_console_holidays: `${api_uri}/v1/admin/morning/holiday`,
    post_console_holiday: `${api_uri}/v1/admin/morning/holiday`,
    put_console_holiday: `${api_uri}/v1/admin/morning/holiday/:holiday_no`,
    delete_console_holiday: `${api_uri}/v1/admin/morning/holiday/:holiday_no`,
    post_console_holiday_sync: `${api_uri}/v1/admin/morning/holiday/sync`,
    post_console_holiday_restore: `${api_uri}/v1/admin/morning/holiday/:holiday_no/restore`,
    get_console_holiday_config: `${api_uri}/v1/admin/morning/holiday/config`,
    put_console_holiday_config: `${api_uri}/v1/admin/morning/holiday/config`,

    // 모닝택배 - 입고지 배송기사 정보 조회 (사용자)
    get_driver_info_warehouses: `${api_uri}/v1/delivery/driver-info/warehouse`,
    get_driver_info_drivers: `${api_uri}/v1/delivery/driver-info/driver`,
    get_driver_info_search: `${api_uri}/v1/delivery/driver-info/search`,

    // 관제서비스
    TODAY_COUNT: `${api_uri}/v1/delivery/location/todayCount`,
    ADDRESS_LIST: `${api_uri}/v1/delivery/location/addressList`,
    INVOICE_LIST: `${api_uri}/v1/delivery/location/todayDelivery`,
    INVOICE_DETAIL: `${api_uri}/v1/delivery/location/todayDeliveryDetail`,
    DRIVER_LIST: `${api_uri}/v1/delivery/location/driverList`,
};
